import { BasePage } from "@Tenants/Fun/Site/BasePage";
import { BaseBlog } from "@Base/Blog/Blog";

import "./Blog.scss";
import "@Base/Home/_Bubbles.scss";

class Blog extends BaseBlog
{
	constructor()
	{
		super();
	}

	public async Initialize(): Promise<void>
	{
		super.Initialize();
	};
}

export class BlogPage extends BasePage
{
	public Blog: Blog;

	constructor()
	{
		super();
		this.Initialize();
	}

	public async Initialize(): Promise<void>
	{
		super.Initialize();
		this.Blog = new Blog();
	};
}

const blog = new BlogPage();